import {MainRequest} from 'Services/common';
import {ColumnType} from 'Stores/commonStore';

export interface GetColumnList extends PaginationAntD {
    catname?: string; //栏目名称
    siteId: string;
}
export interface ColumnList {
    catname: string; //    栏目名称
    caturl: string; //    栏目地址
    cattype: ColumnType; //    栏目类型 1 普通列表 2 搜索
    siteId: string; //    所属网站id
    id: string; //    主键
}

export function getColumnPage(params?: GetColumnList) {
    return MainRequest.post<SuccessData<ColumnList[]>>(
        '/bigdata/getCategories',
        {
            ...params,
            pageNo: params?.current,
            pageSize: params?.pageSize,
        },
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                data: res,
                total: res?.length,
            };
        });
}

export interface ColumnEntityItem extends Omit<ColumnList, 'id'> {
    id?: string;
}
//编辑网站
export function editColumn(data: ColumnEntityItem) {
    return MainRequest.post('/bigdata/saveCategory', data);
}

//删除网站
export function deleteColumn(id: string) {
    return MainRequest.post(`/bigdata/deleteCategory`, {
        id,
    });
}
